export const AUTH = 'AUTH';
export const GET_VALIDATION_CODE = 'GET_VALIDATION_CODE';
export const LOGOUT = 'LOGOUT';
export const LOGIN_CLEAR_ERROR = 'LOGIN_CLEAR_ERROR';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_WHATSAPP_AUTH_NUMBER = 'GET_WHATSAPP_AUTH_NUMBER';
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';

export const INITIAL_AUTHORIZATION_MODAL_FORM_STATE = {
  phone: '+7',
  agreementAccepted: false,
  method: 'sms',
};
